import angular from 'angular';
import angularRoute from 'angular-route';

import PaymentModule from '../payments/payment-module';
import PaymentProfile from './services/payment-profile';
import UserGroup from './services/user-group';
import UserService from './services/user';
import UserPermissions from './services/user-permissions';

import UserProfileCtrl from './user-profile/user-profile-ctrl';
import ManagePlanCtrl from './manage-plan/manage-plan-ctrl';
import ChangePasswordCtrl from './change-password/change-password';
import ChangePasswordDialogCtrl from './change-password/change-password-dialog';
import DeveloperNetworkCtrl from './developer-network/developer-network-ctrl';
import UpgradeFlowCtrl from './upgrade/upgrade-flow-ctrl';
import VisionApiUpgradeCtrl from './visionapi/vision-api-upgrade-ctrl';
import PaymentsCtrl from './payments-profile/payments-profile';
import tabs from './directives/user-details-tabs.js';
import userCanDirective from './directives/user-can.directive';
import userCanFilter from './filters/user-can.filter';
import routes from './user-routes';
import run from './user-run';
import cvapiUsageBar from './directives/cvapi-usage-bar';
import configModule from '../config/config-module';

export default angular.module('user', [angularRoute, PaymentModule, configModule])
    .service('userPermissions', UserPermissions)
    .service('paymentProfile', PaymentProfile)
    .service('userGroup', UserGroup)
    .service('userService', UserService)
    .controller('UserProfileCtrl', UserProfileCtrl)
    .controller('ManagePlanCtrl', ManagePlanCtrl)
    .controller('ChangePasswordCtrl', ChangePasswordCtrl)
    .controller('ChangePasswordDialogCtrl', ChangePasswordDialogCtrl)
    .controller('DeveloperNetworkCtrl', DeveloperNetworkCtrl)
    .controller('UpgradeFlowCtrl', UpgradeFlowCtrl)
    .controller('VisionApiUpgradeCtrl', VisionApiUpgradeCtrl)
    .controller('PaymentsCtrl', PaymentsCtrl)
    .directive('userDetailsTabs', tabs)
    .directive('userCan', userCanDirective)
    .directive('cvapiUsageBar', cvapiUsageBar)
    .filter('userCanFilter', userCanFilter)
    .config(routes)
    .run(['userPermissions', '$rootScope', run])
    .name;



// WEBPACK FOOTER //
// ./user/user-module.js